import axios from 'axios';

// The API stores times in UTC but Mongo hands them back without a timezone marker (e.g. "2026-10-14T05:04:12.345000").
// Browsers parse such strings as LOCAL time, which shifted every timestamp by the UTC offset (6–7 h in New Mexico).
// Tag them as UTC on the way in so new Date(...) and toLocale*() render correct Mountain time for every screen.
const NAIVE_ISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

export const tagUtc = (value) => {
  if (typeof value === 'string') return NAIVE_ISO.test(value) ? `${value}Z` : value;
  if (Array.isArray(value)) { for (let i = 0; i < value.length; i++) value[i] = tagUtc(value[i]); return value; }
  if (value && typeof value === 'object') { for (const k of Object.keys(value)) value[k] = tagUtc(value[k]); return value; }
  return value;
};

axios.interceptors.response.use((res) => {
  const ct = res?.headers?.['content-type'] || '';
  if (ct.includes('application/json') && res.data && typeof res.data === 'object') res.data = tagUtc(res.data);
  return res;
});

// Pin every toLocale*() call to the business time zone (default Albuquerque) unless the caller names a zone itself,
// so a manager travelling out of state still sees schedule, digest and report times in company time.
const TZ_KEY = 'aqh_business_tz';
export const businessTimeZone = () => localStorage.getItem(TZ_KEY) || 'America/Denver';
export const applyBusinessTimeZone = (tz) => { if (tz) localStorage.setItem(TZ_KEY, tz); };
for (const m of ['toLocaleString', 'toLocaleDateString', 'toLocaleTimeString']) {
  const orig = Date.prototype[m];
  Date.prototype[m] = function (locale, options) {
    if (options && options.timeZone) return orig.call(this, locale, options);
    return orig.call(this, locale || 'en-US', { ...(options || {}), timeZone: businessTimeZone() });
  };
}
fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/timezone`).then((r) => (r.ok ? r.json() : null)).then((d) => d && applyBusinessTimeZone(d.timezone)).catch(() => {});
